import React, { CSSProperties, ReactNode, useState } from 'react';
import { useCreateClientWorksetMutation, useCreateProjectWorksetMutation } from '../../../generated/graphql';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { FormField, FormTextArea } from '../../form';
import styles from './NewWorksetDialog.module.css';

type NewWorksetDialogProps = {
    onClose: () => void,
    projectId?: string,
    clientId?: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewWorksetDialog = (props: NewWorksetDialogProps) => {
    const { style, visible, onClose, projectId, clientId } = props;
    const [createClientWorkset, createClientWorksetResult] = useCreateClientWorksetMutation();
    const [createProjectWorkset, createProjectWorksetResult] = useCreateProjectWorksetMutation();
    const [name, setName] = useState('');
    const [group, setGroup] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');

    const handleSubmit = () => {
        if (!name || !group || !description) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        if (clientId) {
            createClientWorkset({
                variables: {
                    id: clientId,
                    workset: {
                        name,
                        group,
                        description,
                    }
                }
            })
                .then(() => { onClose(); })
                .catch(() => {});
        } else if (projectId) {
            createProjectWorkset({
                variables: {
                    id: projectId,
                    workset: {
                        name,
                        group,
                        description,
                    }
                }
            })
                .then(() => { onClose(); })
                .catch(() => {});
        }
    };

    return (
        <DialogBase
            isLoading={createClientWorksetResult.loading || createProjectWorksetResult.loading}
            title="New Workset"
            type='OkCancel'
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            visible={visible}
            className={styles.NewWorksetDialog}
            style={style}
            data-testid="NewWorksetDialog">
            <FormField label="Workset Name" name="name" value={name} onChange={setName} />
            <FormField label="Group" name="group" value={group} onChange={setGroup} />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} />
        </DialogBase>
    );
};

export default NewWorksetDialog;